import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./SelectionSummary.html';
import styles from './SelectionSummary-hashed.scss';
import controller from './SelectionSummaryCtrl';

export default {
    template: cssUtil.hashTemplate(template, styles),
    bindings: {
        selectedVehicles: '=',
        onRemoveVehicle: '&'
    },
    controller
};